import {TipoPagamento} from "../model/TipoPagamento";
import {PagamentoStatus} from "../model/PagamentoStatus";
import Restaurante from "../model/Restaurante";

export class PagamentoDTO {

    formaPagamento?: TipoPagamento;

    idTransacaoMercadoPago?: string;

    status?: PagamentoStatus;

    restaurante?: Restaurante;

}